import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

const selectIndustriesState = (state: RootState) => state.industries;

export const selectIndustries = createSelector(
  selectIndustriesState,
  (industriesState) => industriesState.industries
);
export const selectIndustry = createSelector(
  selectIndustriesState,
  (industriesState) => industriesState.industry
);
